module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-FC-Home.d70592fa.gif";